import React from "react";
import { FullWidthLayout, HorizontalPadding } from "../layout";
import { ChargemasterGrid } from "./list";

export const chargemasterDisplay = (chargemaster: {
  code: string;
  modifier1?: string;
  modifier2?: string;
  modifier3?: string;
  modifier4?: string;
}) => {
  const modifiers = [
    chargemaster.modifier1,
    chargemaster.modifier2,
    chargemaster.modifier3,
    chargemaster.modifier4,
  ].filter((m) => !!m);

  let modifierDisplay =
    modifiers.length > 0 ? `(${modifiers.join(" | ")})` : "";

  return [chargemaster.code, modifierDisplay].filter((x) => !!x).join(" ");
};

export const ChargeMaster: React.FC = () => {
  return (
    <FullWidthLayout
      header={
        <HorizontalPadding>
          <div className="flex justify-between">
            <h1 className="text-2xl font-semibold text-gray-900">
              Chargemaster
            </h1>
          </div>
        </HorizontalPadding>
      }
      content={
        <div className="py-4">
          <ChargemasterGrid />
        </div>
      }
    />
  );
};
